export function setEvents(state, events) {
  state.events = events;
}

export function setPurchasedEvents(state, items) {
  state.purchasedEvents = items;
}